import { attr, belongsTo } from '@warp-drive/legacy/model';
import moment from 'moment';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  end: validator('presence', true),
  format: validator('presence', true),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class MlpCountdownModel extends Model.extend(Validations) {
  @attr end;
  @attr('string', { defaultValue: 'dd:hh:mm:ss' }) format;
  @attr('string') newsletterText;

  // Relations
  @belongsTo('newsletter', { async: true, inverse: null }) newsletter;

  // Getter and setter
  get displayLabel() {
    let end = moment(this.end, 'YYYY-MM-DD hh:mm');
    let isRunning = moment().isBefore(end) ? 1 : 0;

    return this.intl.t('forms.mlp-countdown.displayLabel', {
      end: end.format('DD.MM.YYYY HH:mm'),
      isRunning: isRunning,
    });
  }
}
